import { useMemo, useState } from 'react';
import { Card, Button } from '../components/ui';
import api from '../services/api';

export default function LuaEncrypt() {
  const [productId, setProductId] = useState('');
  const [encryptLevel, setEncryptLevel] = useState(2);
  const [apiUrl, setApiUrl] = useState('https://backend.realsstore.shop/api/validate');
  const [luaCode, setLuaCode] = useState('');
  const [fileName, setFileName] = useState('script.lua');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [okMsg, setOkMsg] = useState('');

  const disabled = useMemo(() => {
    return loading || !productId.trim() || !luaCode.trim();
  }, [loading, productId, luaCode]);

  const onFileSelected = async (file?: File | null) => {
    if (!file) return;
    setFileName(file.name || 'script.lua');
    const text = await file.text();
    setLuaCode(text);
  };

  const downloadBase64 = (base64: string, name: string) => {
    const binary = atob(base64);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
    const blob = new Blob([bytes], { type: 'application/octet-stream' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = name;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  const handleEncrypt = async () => {
    setLoading(true);
    setError('');
    setOkMsg('');
    try {
      const res = await api.post('/admin/encrypt-lua', {
        product_id: String(productId).trim(),
        encrypt_level: Number(encryptLevel),
        api_url: apiUrl.trim(),
        lua_code: luaCode
      });
      if (res.data?.success && res.data?.fileBase64) {
        downloadBase64(res.data.fileBase64, res.data.filename || 'script.luac');
        setOkMsg(`Compilado OK (${res.data.bytes || 0} bytes)`);
      } else {
        setError(res.data?.message || 'No se pudo compilar');
      }
    } catch (e: any) {
      setError(e?.response?.data?.message || 'Error en la compilacion');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-8 max-w-5xl mx-auto">
      <h1 className="font-display text-2xl font-bold text-gray-100 mb-6">Encriptar producto LUA</h1>
      <Card>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div>
            <label className="block text-xs uppercase tracking-wider text-gray-500 mb-2">ID Producto</label>
            <input value={productId} onChange={e => setProductId(e.target.value)} className="w-full bg-rs-surfaceLight border border-rs-border rounded-lg px-3 py-2 text-gray-200" />
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-gray-500 mb-2">Nivel</label>
            <select value={encryptLevel} onChange={e => setEncryptLevel(Number(e.target.value))} className="w-full bg-rs-surfaceLight border border-rs-border rounded-lg px-3 py-2 text-gray-200">
              <option value={1}>Nivel 1</option>
              <option value={2}>Nivel 2</option>
              <option value={3}>Nivel 3</option>
            </select>
          </div>
          <div>
            <label className="block text-xs uppercase tracking-wider text-gray-500 mb-2">Archivo .lua</label>
            <input type="file" accept=".lua" onChange={e => onFileSelected(e.target.files?.[0])} className="w-full bg-rs-surfaceLight border border-rs-border rounded-lg px-3 py-2 text-gray-200" />
          </div>
        </div>

        <div className="mb-4">
          <label className="block text-xs uppercase tracking-wider text-gray-500 mb-2">API Validate</label>
          <input value={apiUrl} onChange={e => setApiUrl(e.target.value)} className="w-full bg-rs-surfaceLight border border-rs-border rounded-lg px-3 py-2 text-gray-200" />
        </div>

        <div className="mb-4">
          <label className="block text-xs uppercase tracking-wider text-gray-500 mb-2">Codigo LUA ({fileName})</label>
          <textarea value={luaCode} onChange={e => setLuaCode(e.target.value)} rows={14} className="w-full bg-rs-surfaceLight border border-rs-border rounded-lg px-3 py-2 text-gray-200 font-mono" />
        </div>

        <div className="flex items-center gap-3">
          <Button onClick={handleEncrypt} disabled={disabled} loading={loading}>
            Encriptar y descargar .luac
          </Button>
          {okMsg && <span className="text-green-400 text-sm">{okMsg}</span>}
          {error && <span className="text-red-400 text-sm">{error}</span>}
        </div>
      </Card>
    </div>
  );
}
